import { GET_ENC, POST_ENC } from "../common/EncryptedHttp";
import { BASE_URL } from "../common/const";

const BASE = `${BASE_URL}/api/OpthalRefraction`;

// Unaided Distance VA
export const GetSphereDistantList = (params: any) =>
  GET_ENC(`${BASE}/GetSphereDistantList?` + params, null);

export const GetSphereDistantDetail = (params: any) =>
  GET_ENC(`${BASE}/GetSphereDistantDetail?` + params, null);

export const CreateSphereDistant = (data: any) =>
  POST_ENC(`${BASE}/CreateSphereDistant`, data);

export const UpdateSphereDistant = (data: any) =>
  POST_ENC(`${BASE}/UpdateSphereDistant`, data);

export const DeleteSphereDistant = (data: any) =>
  POST_ENC(`${BASE}/DeleteSphereDistant`, data);

// Pinhole VA
export const GetVisionDistantList = (params: any) =>
  GET_ENC(`${BASE}/GetVisionDistantList?` + params, null);

export const GetVisionDistantDetail = (params: any) =>
  GET_ENC(`${BASE}/GetVisionDistantDetail?` + params, null);

export const CreateVisionDistant = (data: any) =>
  POST_ENC(`${BASE}/CreateVisionDistant`, data);

export const UpdateVisionDistant = (data: any) =>
  POST_ENC(`${BASE}/UpdateVisionDistant`, data);

export const DeleteVisionDistant = (data: any) =>
  POST_ENC(`${BASE}/DeleteVisionDistant`, data);

// Best Corrected VA
export const GetVisionNearAddList = (params: any) =>
  GET_ENC(`${BASE}/GetVisionNearAddList?` + params, null);

export const GetVisionNearAddDetail = (params: any) =>
  GET_ENC(`${BASE}/GetVisionNearAddDetail?` + params, null);

export const CreateVisionNearAdd = (data: any) =>
  POST_ENC(`${BASE}/CreateVisionNearAdd`, data);

export const UpdateVisionNearAdd = (data: any) =>
  POST_ENC(`${BASE}/UpdateVisionNearAdd`, data);

export const DeleteVisionNearAdd = (data: any) =>
  POST_ENC(`${BASE}/DeleteVisionNearAdd`, data);

// Near Vision
export const GetSphereNearAddList = (params: any) =>
  GET_ENC(`${BASE}/GetSphereNearAddList?` + params, null);

export const GetSphereNearAddDetail = (params: any) =>
  GET_ENC(`${BASE}/GetSphereNearAddDetail?` + params, null);

export const CreateSphereNearAdd = (data: any) =>
  POST_ENC(`${BASE}/CreateSphereNearAdd`, data);

export const UpdateSphereNearAdd = (data: any) =>
  POST_ENC(`${BASE}/UpdateSphereNearAdd`, data);

export const DeleteSphereNearAdd = (data: any) =>
  POST_ENC(`${BASE}/DeleteSphereNearAdd`, data);

// Final Visual Acuity
export const GetCylinderList = (params: any) =>
  GET_ENC(`${BASE}/GetCylinderList?` + params, null);

export const GetCylinderDetail = (params: any) =>
  GET_ENC(`${BASE}/GetCylinderDetail?` + params, null);

export const CreateCylinder = (data: any) =>
  POST_ENC(`${BASE}/CreateCylinder`, data);

export const UpdateCylinder = (data: any) =>
  POST_ENC(`${BASE}/UpdateCylinder`, data);

export const DeleteCylinder = (data: any) =>
  POST_ENC(`${BASE}/DeleteCylinder`, data);

// Final Visual Acuity
export const GetAxisList = (params: any) =>
  GET_ENC(`${BASE}/GetAxisList?` + params, null);

export const GetAxisDetail = (params: any) =>
  GET_ENC(`${BASE}/GetAxisDetail?` + params, null);

export const CreateAxis = (data: any) =>
  POST_ENC(`${BASE}/CreateAxis`, data);

export const UpdateAxis = (data: any) =>
  POST_ENC(`${BASE}/UpdateAxis`, data);

export const DeleteAxis = (data: any) =>
  POST_ENC(`${BASE}/DeleteAxis`, data);
